// components/ui/post-skeleton.tsx
export default function PostSkeleton() {
    return (
        <div className="overflow-hidden rounded-lg border bg-card dark:bg-slate-800 dark:border-gray-700">
            <div className="relative h-48 w-full animate-pulse bg-muted dark:bg-gray-700" />
            <div className="p-4 space-y-3">
                <div className="h-6 w-3/4 animate-pulse rounded bg-muted dark:bg-gray-700" />
                <div className="space-y-2">
                    <div className="h-4 w-full animate-pulse rounded bg-muted dark:bg-gray-700" />
                    <div className="h-4 w-5/6 animate-pulse rounded bg-muted dark:bg-gray-700" />
                    <div className="h-4 w-4/6 animate-pulse rounded bg-muted dark:bg-gray-700" />
                </div>
            </div>
        </div>
    );
}